class TrainingModel{
    presentation;
    public;
    goals;
    competence;
    thematique;
    cost;
    duree;
    methode;
    evaluation;
    quality;
    name;
    id;
    type;
    dateDebut;
    dateFin;
    publicDisplay;
    secondaryId;
    modif;
    rating;
    document;
    sessions;
    idSecond;
    accessibility;
    prixMax;
    groupes;
    groupesMax;
    qualification;
    cpf;
    prerequis;
    ins_title;
    ins_subtitle;
    ins_button;
    ins_button_tel;

    constructor(){

    }
}

export default TrainingModel;